import { ElementRef, Injector, Component, OnInit, ViewChild, AfterViewChecked } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { modifyClassElement, REMOVE_CLASS, ADD_CLASS } from '../../../Utils/utils';
import { isEqual, isEmpty, find, head, forEach, merge, filter, stubFalse } from 'lodash';
import { LinkExpirationServie } from '../../../Services/link-expiration/link-expiration';
import * as bowser from 'bowser';
import * as zenscroll from 'zenscroll';
import { ActionApiService } from 'src/app/Services/action-api/action-api.service';
import { EventsComponent } from '../events/events.component';

@Component({
	selector: 'comparison',
	host: { '[class]': 'myCustomClass' },
	templateUrl: './comparison.component.html',
	styleUrls: ['./comparison.component.scss'],
})
export class ComparisonComponent extends EventsComponent implements OnInit, AfterViewChecked {
	comparisonSectionVisible = false;
	isCompactTable = false;
	showTooltip = -1;
	isOpen: boolean;
	isMobile: boolean;
	gtmRatesObject: any;
	SecondOnlineBuyActive = false;
	showSummary = false;
	SCROLL_OFFSET = 30;
	SCROLL_DURATION = 800;
	rightShadowClass = 'comparison-shadow-right';
	leftShadowClass = 'comparison-shadow-left';
	shadowTableClass = false;
	isCollapsed: any;
	longerTd = {};
	CoveragesList: any[];
	selectedPackageType = '';
	@ViewChild('comparisonTable', { static: true, read: ElementRef })
	comparisonTable: ElementRef;
	isAgentflowType: boolean;
	toggleShowComparison: boolean;
	toggleShowComparisonLoader: boolean;
	carriersFeaturesPopup: boolean;
	isCovModFlagOn: boolean = false;

	constructor(
		injector: Injector,
		private el: ElementRef,
		private linkExpiration: LinkExpirationServie,
		private actionApiService: ActionApiService,
		private sanitizer: DomSanitizer
	) {
		super(injector);
	}

	ngOnInit() {
		this.gaLabel = 'CompareRates';
		this.isMobile =
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile' ||
			bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet';

		this.toggleShadowsElements();

		this.carriersFeaturesPopup = this.control.attributes.CarriersBenefitsOnPopup;

		this.layoutService.globalAttributes.subscribe((data) => {
			this.toggleShowComparison = data['showComparison'];
			this.toggleShowComparisonLoader = data['showComparisonLoader'];
			this.isCovModFlagOn = data['covModFlag'];
		});

		window.addEventListener('resize', ($event) => {
			this.toggleShadowsElements();
		});

		this.observablesService.scrollTop.subscribe(() => {
			if (this.control.attributes.scrollOnSelect) {
			}
		});

		this.observablesService.OnlineBuyActive.subscribe((res) => {
			this.SecondOnlineBuyActive = res;
		});

		this.layoutService.staticLayout.subscribe((data) => {
			if (data && data.data.metadata.page.stage == 'YourRates') {
				this.filterEmptyCoverages();
			}
		});

		this.CoveragesList = this.control.attributes.coverages;
		if (this.control.attributes.options && this.control.attributes.options.length > 0) {
			const firstOption = head(this.control.attributes.options);
			this.isAgentflowType = (firstOption as any).bridgeButton.attributes.flowType === 'Agent';
		}

		forEach(this.control.attributes.options, (insurer) => {
			if (insurer.value.hasPackage) {
				const isValueSelected = isEqual(insurer.value.name, this.value.name);

				insurer.value.packageCoverages = insurer.packageCoverages;
				insurer.value.coverages = this.control.attributes.coverages;
				if (isValueSelected) {
					this.storeService.updateData('CarrierInformation', insurer.value, this.context);
					this.value = insurer.value;
				}
			}
		});

		this.filterEmptyCoverages();
	}

	ngAfterViewChecked() {
		this.cdRef.detectChanges();
	}

	isSelected(value) {
		return isEqual(value.name, this.value.name);
	}

	showBenefitsPopup() {
		const requestBody: request = {
			data: {},
			info: {
				action: 'CarrierFeaturesBenefitsModal',
				conditions: '',
				elementSrc: '',
				stage: '',
				notRenderPage: false,
			},
		};
		this.actionApiService.invokeAction(requestBody);
		if (this.carriersFeaturesPopup) {
		}
	}

	showComparisonSection() {
		this.comparisonSectionVisible = !this.comparisonSectionVisible;
		if (this.comparisonSectionVisible) {
			this.storeService.setGlobalAttribute('shouldFireCompareRatesGaEvent', true);

			const requestBody: request = {
				data: {
					dbAction: 'Show Rate Comparison',
					commentTran: 'Rate Comparison Table displayed to Consumer.',
				},
				info: {
					action: 'GenerateCrmNote',
					conditions: '',
					elementSrc: '',
					stage: '',
					notRenderPage: true,
				},
				isRemoteAction: true,
			};

			this.actionApiService.invokeAction(requestBody);
		} else {
			this.storeService.setGlobalAttribute('showComparison', false);
		}
		// this.observablesService.ComparisonSectionVisible.next(this.comparisonSectionVisible);
		this.toggleShadowsElements();
		this.shadowTableClass = this.shouldAddShadowToTable();
	}

	toggleShadowsElements() {
		this.removeShadowsFromTable();
		if (!this.isMobile) {
			return false;
		}

		if (this.comparisonSectionVisible) {
			this.isCompactTable = this.detectTableIsCompact();

			if (this.isCompactTable) {
				this.registerTableScrollingEvents();
			}
		}
	}

	removeShadowsFromTable() {
		const comparisonWrapperElement = this.el.nativeElement.querySelector('.comparison-wrap');
		if (comparisonWrapperElement) {
			modifyClassElement(comparisonWrapperElement, 'comparison-shadow-right', REMOVE_CLASS);
			modifyClassElement(comparisonWrapperElement, 'comparison-shadow-left', REMOVE_CLASS);
		}
	}

	registerTableScrollingEvents() {
		setTimeout(() => {
			this.el.nativeElement.querySelector('.comparison-wrap').addEventListener('scroll', (eArgs) => {
				const tableElement = eArgs.target;

				const topRight = tableElement.scrollWidth - tableElement.scrollLeft < tableElement.clientWidth + 5;
				const topLeft = tableElement.scrollLeft === 0;

				if (topRight && !topLeft) {
					modifyClassElement(tableElement, this.rightShadowClass, REMOVE_CLASS);
				}
				if (topLeft && !topRight) {
					modifyClassElement(tableElement, this.leftShadowClass, REMOVE_CLASS);
				} else if (!topRight && !topLeft) {
					modifyClassElement(tableElement, this.rightShadowClass, ADD_CLASS);
					modifyClassElement(tableElement, this.leftShadowClass, ADD_CLASS);
				}
			});
		});
	}

	detectTableIsCompact() {
		return this.comparisonSectionVisible && window.innerWidth <= 600;
	}

	shouldAddShadowToTable() {
		if (this.comparisonSectionVisible && this.isMobile) {
			const tableElement = this.comparisonTable.nativeElement;
			if (tableElement) {
				// more than 2 rates need to add shadow to the right of the table
				if (
					tableElement.childNodes[1] &&
					tableElement.childNodes[1].childNodes &&
					tableElement.childNodes[1].childNodes[1] &&
					tableElement.childNodes[1].childNodes[1].childNodes &&
					tableElement.childNodes[1].childNodes[1].childNodes[1] &&
					tableElement.childNodes[1].childNodes[1].childNodes[1].childElementCount > 3
				) {
					return true;
				}
			}
		} else {
			if (this.comparisonTable) {
				this.comparisonTable.nativeElement.scrollLeft = 0;
			}
		}
		return false;
	}

	toggleTooltip(index) {
		if (this.showTooltip === -1 || this.showTooltip !== index) {
			this.showTooltip = index;
			this.isOpen = true;

			setTimeout(() => {
				// Get visible benefit tooltip, only one should be displayed
				const currentTooltip = this.el.nativeElement.querySelector('.benefits-tooltip');
				// Get comparison wrapper
				const comparisonWrap = this.el.nativeElement.querySelector('.comparison-wrap');

				if (currentTooltip.length > 0) {
					// Get elemnts sizes and positions
					const comparisonRect = comparisonWrap[0].getBoundingClientRect();
					const tooltipRect = currentTooltip[0].getBoundingClientRect();

					// Check if there is overflow in tooltip position vs wrapper dimensions
					if (this.isOpen && tooltipRect.left < comparisonRect.left - 15) {
						comparisonWrap[0].scrollLeft += tooltipRect.left - comparisonRect.left - 10;
					} else if (this.isOpen && tooltipRect.right > comparisonRect.right - 15) {
						comparisonWrap[0].scrollLeft -= comparisonRect.right - tooltipRect.right - 10;
					}
				}
			});
		} else {
			this.showTooltip = -1;
			this.isOpen = false;
		}

		if (this.isMobile) {
			this.handleTooltipGtmEvent(this.control.attributes.options[index], this.isOpen);
		}
	}

	handleTooltipGtmEvent(selectedOption, isOpen) {}

	focusLostCallback() {
		if (this.isOpen) {
			// this.$rootScope.activeElement = null;
			this.isOpen = true;
		} else {
			this.isOpen = false;
		}

		// this.$rootScope.activeElement &&
		// 	angular.element(this.$rootScope.activeElement) &&
		// 	angular.element(this.$rootScope.activeElement).attr('class') !== null &&
		// 	angular.element(this.$rootScope.activeElement).attr('class').indexOf('benefit') !== -1
	}

	toggleCollapsed() {
		this.isCollapsed = !this.isCollapsed;
	}

	selectInsurer(insurer) {
		let isRequote = false;

		const currentSelectedCarrier = this.storeService.getValue('CarrierInformation', this.context);

		if (!this.carrierInformationService.isCovModCarrierSeen && currentSelectedCarrier.isCustomizable) {
			this.carrierInformationService.setIsCovModCarrierSeen(true);
		}

		// Only PAA should be able to bridge
		if (insurer.bridgeButton.attributes.flowType !== 'Consumer' && !this.isCovModFlagOn) {
			if (!this.linkExpiration.validateLinkExpiration(insurer.ajaxInfo, insurer.bridgeButton.attributes.ReQuotedData)) {
				insurer.bridgeButton.attributes.url = this.sanitize('javascript:void(0);');
				insurer.bridgeButton.attributes.target = '_self';
				isRequote = true;
			}
		}

		this.storeService.updateData(
			'CarrierInformation',
			{ ...insurer.value, packageType: this.selectedPackageType },
			this.context
		);

		if (this.isCovModFlagOn) {
			var carrierInformation = this.storeService.getValue('CarrierInformation', this.context);
			carrierInformation.isCustomizable = insurer.value.isCustomizable;
			this.storeService.updateData('CarrierInformation', carrierInformation, this.context);
		}

		const staticLayout = this.layoutService.staticLayout.getValue();
		this.layoutService.staticLayout.next(staticLayout);

		if (insurer.referDescription) {
			this.storeService.updateData(
				'BridgeNote',
				{
					ActionValue: 'Completed - Referred to Assurant',
					CarrierValue: insurer.name,
					CallProductType: insurer.value ? insurer.value.lobname : null,
					ActivityDescription: insurer.referDescription,
				},
				this.context
			);
		} else {
			this.storeService.updateData(
				'BridgeNote',
				{ ActionValue: '', CarrierValue: '', CallProductType: '', ActivityDescription: '' },
				this.context
			);
		}

		const globalAttr = this.storeService.getGlobalAttributes();
		const isComparisonToggle = globalAttr && globalAttr['showComparison'];
		this.value = insurer.value;

		if (isComparisonToggle) {
			this.storeService.setGlobalAttribute('showComparisonLoader', true);
		}

		this.actionService.ajaxAction(insurer.ajaxInfo, this.context);

		this.observablesService.insurerSelected.next();
		const el = document.getElementById('curentQuote');

		if (el !== null) {
			zenscroll.center(el);
		}

		if (
			!(insurer.disabled || insurer.referDescription) &&
			insurer.bridgeButton.attributes.flowType !== 'Consumer' &&
			!isRequote &&
			!this.isCovModFlagOn
		) {
			var win = window.open(this.setHref(insurer), insurer.bridgeButton.attributes.target);
			win.focus();
		}
	}

	setHref(insurer) {
		// Only PAA should be able to bridge
		if (insurer.bridgeButton.attributes.flowType !== 'Consumer') {
			this.linkExpiration.setLinkExpiration(insurer.bridgeButton.attributes.ReQuotedData);
			return this.control.disabled
				? ''
				: !isEmpty(insurer.bridgeButton.attributes.url)
				? insurer.bridgeButton.attributes.url
				: '';
		} else {
			return this.sanitize('javascript:void(0);');
		}
	}

	getcomparisonSectionVisible() {
		return this.comparisonSectionVisible ? 'Comparison_Section_Show' : 'Comparison_Section_Hide';
	}

	getInsurer(insurer: any) {
		if (insurer && insurer.total && typeof insurer.total === 'string') {
			return insurer.total.replace(',', '');
		}
		return insurer.total;
	}

	sanitize(url: string) {
		return this.sanitizer.bypassSecurityTrustUrl(url);
	}

	// assign target attribute to anchors: if consumer flow: no target attribute, if agent: 'target: _blank':
	assignTargetAttributeToAnchor(flowType) {
		return flowType === 'Agent' ? '_blank' : '_self';
	}

	getCoverageValue(value: string, coverage): string {
		// return value === 'Actual Losses Sustained' ? 'Actual Losses <br> Sustained' : value;
		if (value === 'Actual Losses Sustained') {
			this.longerTd[coverage.id] = true;
			return 'Actual Losses <br> Sustained';
		} else {
			return (isEmpty(value) || value === 'N/A' || value === 'NA' || value === 'Not Applicable' || value === 'None') &&
				((coverage.packageInfo && coverage.packageInfo.additional) ||
					coverage.title === 'Extended dwelling' ||
					coverage.title === 'Water backup coverage')
				? '-'
				: value === 'None'
				? 'Not Applicable'
				: value;
		}
	}

	isPackageType(coverage, insurer) {
		if (this.isAgentflowType && coverage.packageInfo && coverage.packageInfo.carrierName === insurer.name) {
			if (
				coverage.packageInfo.visibleAndHighlightNew &&
				coverage.packageInfo.visibleAndHighlightNew.indexOf(this.selectedPackageType) > -1
			) {
				return true;
			}

			if (
				coverage.packageInfo.highlightDifferentValue &&
				coverage.packageInfo.highlightDifferentValue.indexOf(this.selectedPackageType) > -1
			) {
				return true;
			}
		}
		return false;
	}

	higherTd(id) {
		return this.longerTd[id];
	}

	updatePackage(event) {
		this.selectedPackageType = this.capitalize(event.toLowerCase());

		forEach(this.control.attributes.options, (insurer) => {
			if (insurer.value.hasPackage && insurer.packageCoverages && insurer.packageCoverages.length > 0) {
				const packageresults = find(insurer.packageCoverages, {
					packageType: this.selectedPackageType,
				});
				insurer.results = packageresults.results;
				insurer.total = packageresults.price;
			}
		});

		this.filterEmptyCoverages();
	}

	filterEmptyCoverages() {
		const NotApplicableValues = ['N/A', 'NA', 'Not Applicable', 'None'];

		this.CoveragesList = this.control.attributes.coverages;

		const filteredCoveragesList = this.CoveragesList.filter((coverage) => {
			const results = this.control.attributes.options.map((option) => {
				const resultValue = option.results && option.results[coverage.id];
				return resultValue ? resultValue.trim() : null;
			});

			// Check if all values in the results are in the NotApplicableValues array
			const allValuesNotApplicable = results.every((value) => value !== null && NotApplicableValues.includes(value));

			// Keep the coverage if not all values are "not applicable"
			return !allValuesNotApplicable;
		});

		// Update CoveragesList with the filtered list
		this.CoveragesList = filteredCoveragesList;
	}

	isPackageSelected(coverage) {
		if (coverage.packageInfo && coverage.packageInfo.additional) {
			return coverage.packageInfo.visibleAndHighlightNew.indexOf(this.selectedPackageType) > -1;
		}
	}

	showCoverageTitle(coverage) {
		if (coverage.packageInfo && coverage.packageInfo.additional) {
			const packageArr = coverage.packageInfo.visibleAndHighlightNew || [];
			const isPackageSelected = packageArr.indexOf(this.selectedPackageType) > -1;
			if (isPackageSelected) {
				const selectedCarrierWithPackages = find(this.control.attributes.options, {
					name: coverage.packageInfo.carrierName,
				});
				if (selectedCarrierWithPackages) {
					selectedCarrierWithPackages.results = find(selectedCarrierWithPackages.packageCoverages, {
						packageType: this.selectedPackageType,
					}).results;
				}
				return true;
			}
			return false;
		}
		return true;
	}

	setPlaceHolder(packageCoverages: any[]) {
		if (!isEmpty(this.selectedPackageType)) {
			return this.selectedPackageType;
		} else {
			const selectedPackage = head(
				filter(packageCoverages, (item) => {
					return item.selected;
				})
			);
			this.updatePackage((selectedPackage && selectedPackage.packageType) || 'POPULAR');
			if (selectedPackage) {
				this.selectedPackageType = selectedPackage.packageType;
				return selectedPackage.packageType.toUpperCase();
			}
			return 'POPULAR';
		}
	}

	capitalize = (s) => {
		if (typeof s !== 'string') {
			return '';
		}
		return s.charAt(0).toUpperCase() + s.slice(1);
	};
}
